import Layout from "./Layout";
import Seo from "../Seo";

/**
 * Wraps a bare page (e.g. the legal pages, which only render their own content
 * block) in the site chrome (Header + Footer) and applies per-page SEO.
 */
export default function PageShell({ title, description, path, children }) {
  return (
    <Layout>
      <Seo title={title} description={description} path={path} />
      {children}
    </Layout>
  );
}
